import { Tooltip } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HelpIcon from "@material-ui/icons/HelpOutline";
import InfoIcon from "@material-ui/icons/Info";
import PropTypes from "prop-types";
import React from "react";
import DefaultInfoFields from "../../constants/DefaultInfoFields";
import DefaultInfoFieldsReferees from "../../constants/DefaultInfoFieldsReferees";
import { languages } from "../../constants/languages";
import SignupNameQuestion from "../../constants/SignupNameQuestion";
import DeleteInfoFieldContainer from "../../containers/teams/DeleteInfoFieldContainer";
import EditInfoFieldContainer from "../../containers/teams/EditInfoFieldContainer";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  heading: {
    fontWeight: 500,
  },
});

function EditInfoCard(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.heading}>
            {props.refereesPage
              ? props.tournament.useJudges
                ? languages.teamInfo.titleJudges
                : languages.teamInfo.titleReferees
              : props.tournament.individualPlayers
              ? languages.teamInfo.title2
              : languages.teamInfo.title}
          </Typography>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails>
          <div>
            <Typography variant="caption">
              {props.refereesPage
                ? props.tournament.useJudges
                  ? languages.teamInfo.descriptionReferees2
                  : languages.teamInfo.descriptionReferees
                : languages.formatString(
                    languages.teamInfo.description,
                    props.tournament.individualPlayers
                      ? languages.teams.playersLow
                      : languages.tournament.teamsLow
                  )}
            </Typography>
          </div>
        </ExpansionPanelDetails>
        {props.refereesPage ? (
          <div style={{ padding: "0 16px" }}>
            <Typography
              variant="body2"
              style={{
                background: "rgb(236, 239, 241)",
                padding: 10,
                borderRadius: 5,
                width: "100%",
                cursor: "pointer",
              }}
              onClick={(e) => {
                props.handleToJudgesClick(
                  e,
                  props.tournament.useJudges ? false : true
                );
              }}
            >
              <InfoIcon
                style={{
                  height: 15,
                  width: 15,
                  marginRight: 3,
                  top: 2,
                  position: "relative",
                }}
              />
              {props.tournament.useJudges
                ? languages.teamInfo.toRefereeSport
                : languages.teamInfo.toJudgeSport}
            </Typography>
          </div>
        ) : (
          <div style={{ padding: "0 16px" }}>
            <Typography
              variant="body2"
              style={{
                background: "rgb(236, 239, 241)",
                padding: 10,
                borderRadius: 5,
                width: "100%",
                cursor: "pointer",
              }}
              onClick={(e) => {
                props.handleToPlayersClick(
                  e,
                  props.tournament.individualPlayers ? false : true
                );
              }}
            >
              <InfoIcon
                style={{
                  height: 15,
                  width: 15,
                  marginRight: 3,
                  top: 2,
                  position: "relative",
                }}
              />
              {props.tournament.individualPlayers
                ? languages.teamInfo.toTeamSport
                : languages.teamInfo.toIndividualSport}
            </Typography>
          </div>
        )}
        {!props.refereesPage && (
          <ExpansionPanelDetails>
            <table style={{ marginTop: 15, width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: 500 }}>
                    {languages.teamInfo.defaultData}
                  </td>
                </tr>
                {Object.keys(DefaultInfoFields).map((key) => {
                  const infoField = DefaultInfoFields[key];
                  infoField["id"] = key;
                  let show = ((props.tournament.defaultFields || {})[key] || {})
                    .show;
                  if (
                    show === undefined &&
                    (key === "players" || key === "logo")
                  ) {
                    show = true;
                  } else if (show === undefined) {
                    show = false;
                  }

                  if (key === "present" && props.tournament.requireCheckIn) {
                    show = true;
                  }
                  // let signup =
                  //   ((props.tournament.defaultFields || {})[key] || {}).signup ||
                  //   false;

                  if (key === "players" && props.tournament.individualPlayers) {
                    return <tr key={key} />;
                  } else if (
                    key === "language" &&
                    (props.tournament.lang || []).length < 2
                  ) {
                    return <tr key={key} />;
                  } else {
                    return (
                      <tr key={key}>
                        <td
                          style={{
                            width: "90%",
                            padding: 0,
                            verticalAlign: "middle",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{ display: "inline" }}
                          >
                            {key === "present" &&
                            props.tournament.requireCheckIn
                              ? languages.teams.checkedIn
                              : infoField.name}
                          </Typography>

                          {infoField.tooltip ? (
                            <Tooltip title={infoField.tooltip} placement="top">
                              <HelpIcon
                                style={{
                                  height: 15,
                                  width: 15,
                                  marginLeft: 5,
                                  position: "relative",
                                  top: 2,
                                }}
                              />
                            </Tooltip>
                          ) : null}
                        </td>
                        <td style={{ padding: 0 }}>
                          <Checkbox
                            checked={show}
                            onClick={(event) => {
                              props.handleCheck(event, key, "show");
                            }}
                            color="primary"
                            style={{ height: 32, padding: 0 }}
                            disabled={
                              key === "present" &&
                              props.tournament.requireCheckIn
                            }
                          />
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </ExpansionPanelDetails>
        )}

        {!props.refereesPage &&
          Object.keys(props.tournament.infoFields || {}).length > 0 && (
            <ExpansionPanelDetails style={{ overflowX: "auto" }}>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ fontWeight: 500 }}>
                      {languages.teamInfo.customData}
                    </td>
                  </tr>
                  {/* <tr>
                <td style={{ width: "80%" }}>
                  <Typography>{languages.general.name}</Typography>
                </td>
                <td>
                  <EditInfoFieldContainer
                    tournament={props.tournament}
                    infoField={{ name: languages.general.name }}
                    disabled={true}
                  />
                </td>
                <td>
                  <DeleteInfoFieldContainer
                    tournament={props.tournament}
                    disabled={true}
                  />
                </td>
              </tr> */}
                  {Object.keys(props.tournament.infoFields || {}).map((key) => {
                    const infoField = Object.assign(
                      {},
                      props.tournament.infoFields[key]
                    );
                    infoField["id"] = key;
                    return (
                      <tr key={key}>
                        <td style={{ width: "80%" }}>
                          <Typography variant="body2">
                            {infoField.name}
                          </Typography>
                        </td>
                        <td style={{ width: "10%" }}>
                          <EditInfoFieldContainer
                            tournament={props.tournament}
                            infoField={infoField}
                            teamsContactInfo={props.teamsContactInfo}
                          />
                        </td>
                        <td style={{ width: "10%" }}>
                          <DeleteInfoFieldContainer
                            tournament={props.tournament}
                            infoFieldId={key}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </ExpansionPanelDetails>
          )}

        {props.refereesPage && (
          <ExpansionPanelDetails>
            <table style={{ marginTop: 15, width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: 500 }}>
                    {languages.teamInfo.defaultData}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "90%", padding: 0 }}>
                    <Typography variant="body2" style={{ display: "inline" }}>
                      {languages.teams.country}
                    </Typography>
                  </td>
                  <td style={{ padding: 0 }}>
                    <Checkbox
                      checked={
                        (
                          (props.tournament.defaultFields || {})[
                            "refereeCountry"
                          ] || {}
                        ).show
                      }
                      onClick={(event) => {
                        props.handleCheck(event, "refereeCountry", "show");
                      }}
                      color="primary"
                      style={{ height: 32, padding: 0 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "90%", padding: 0 }}>
                    <Typography variant="body2" style={{ display: "inline" }}>
                      {languages.teamInfo.shareURL}
                    </Typography>
                    <Tooltip
                      title={
                        props.tournament.useJudges
                          ? languages.teamInfo.shareURLDescriptionJudges
                          : languages.teamInfo.shareURLDescription2
                      }
                      placement="top"
                    >
                      <HelpIcon
                        style={{
                          height: 15,
                          width: 15,
                          marginLeft: 5,
                          position: "relative",
                          top: 2,
                        }}
                      />
                    </Tooltip>
                  </td>
                  <td style={{ padding: 0 }}>
                    <Checkbox
                      checked={
                        (
                          (props.tournament.defaultFields || {})[
                            "refereeShareURL"
                          ] || {}
                        ).show ||
                        (
                          (props.tournament.defaultFields || {})[
                            "refereeShareURL"
                          ] || {}
                        ).show === undefined
                      }
                      onClick={(event) => {
                        props.handleCheck(event, "refereeShareURL", "show");
                      }}
                      color="primary"
                      style={{ height: 32, padding: 0 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 500, paddingTop: 24 }}>
                    {languages.referees.wishes}
                  </td>
                </tr>
                {Object.keys(DefaultInfoFieldsReferees).map((key) => {
                  const infoField = DefaultInfoFieldsReferees[key];
                  infoField["id"] = key;
                  let show = (
                    (props.tournament.defaultFieldsReferees || {})[key] || {}
                  ).show;
                  if (show === undefined) {
                    show = false;
                  }
                  return (
                    <tr key={key}>
                      <td style={{ width: "90%", padding: 0 }}>
                        <Typography variant="body2">
                          {infoField.name}
                        </Typography>
                      </td>
                      <td style={{ padding: 0 }}>
                        <Checkbox
                          checked={show}
                          onClick={(event) => {
                            props.handleCheckReferees(event, key, "show");
                          }}
                          color="primary"
                          style={{ height: 32, padding: 0 }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </ExpansionPanelDetails>
        )}
        {props.refereesPage &&
          Object.keys(props.tournament.infoFieldsReferees || {}).length > 0 && (
            <ExpansionPanelDetails style={{ overflowX: "auto" }}>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ fontWeight: 500 }}>
                      {languages.teamInfo.informationFields}
                    </td>
                  </tr>

                  {Object.keys(props.tournament.infoFieldsReferees || {}).map(
                    (key) => {
                      const infoField = Object.assign(
                        {},
                        props.tournament.infoFieldsReferees[key]
                      );
                      infoField["id"] = key;
                      return (
                        <tr key={key}>
                          <td style={{ width: "80%" }}>
                            <Typography variant="body2">
                              {infoField.name}
                            </Typography>
                          </td>
                          <td>
                            <EditInfoFieldContainer
                              tournament={props.tournament}
                              infoField={infoField}
                              refereesPage={props.refereesPage}
                            />
                          </td>
                          <td>
                            <DeleteInfoFieldContainer
                              tournament={props.tournament}
                              infoFieldId={key}
                              refereesPage={props.refereesPage}
                            />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </ExpansionPanelDetails>
          )}

        <ExpansionPanelDetails>
          <EditInfoFieldContainer
            tournament={props.tournament}
            refereesPage={props.refereesPage}
            teamsContactInfo={props.teamsContactInfo}
          />
        </ExpansionPanelDetails>

        {!props.refereesPage &&
          (Object.keys(props.tournament.questions || {}).length > 0 ||
            props.tournament.online) && (
            <ExpansionPanelDetails>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ fontWeight: 500 }}>
                      {languages.signupPage.signupQuestions}
                    </td>
                  </tr>
                  {props.tournament.online && (
                    <tr>
                      <td style={{ width: "90%", padding: 0 }}>
                        <Typography variant="body2">
                          {props.tournament.teamSignupQuestion2 ||
                            SignupNameQuestion.gamertagQuestion[
                              (props.tournament.lang || [])[0]
                                ? (props.tournament.lang || [])[0]
                                : languages.getLanguage()
                            ]}
                        </Typography>
                      </td>
                      <td style={{ width: "10%" }}>
                        <Checkbox
                          checked={
                            props.tournament.showTeamSignupQuestion2Table !==
                            undefined
                              ? props.tournament.showTeamSignupQuestion2Table
                              : props.tournament.showTeamSignupQuestion2 !==
                                undefined
                              ? props.tournament.showTeamSignupQuestion2
                              : false
                          }
                          onClick={(event) => {
                            props.handleQuestionCheck(event, "1", "show");
                          }}
                          color="primary"
                          style={{ height: 32, padding: 0 }}
                        />
                      </td>
                    </tr>
                  )}
                  {Object.keys(props.tournament.questions || {})
                    .filter(
                      (key) =>
                        props.tournament.questions[key].perSignup !== true
                    )
                    .sort((a, b) => {
                      const qA = props.tournament.questions[a];
                      const qB = props.tournament.questions[b];
                      if (qA.num > qB.num) {
                        return 1;
                      } else if (qA.num < qB.num) {
                        return -1;
                      } else {
                        return 0;
                      }
                    })
                    .map((key) => {
                      const infoField = props.tournament.questions[key];
                      infoField["id"] = key;
                      let show = infoField.show;
                      if (show === undefined) {
                        show = false;
                      }

                      return (
                        <tr key={key}>
                          <td style={{ width: "90%" }}>
                            <Typography variant="body2">
                              {infoField.name}
                            </Typography>
                          </td>
                          <td style={{ width: "10%" }}>
                            <Checkbox
                              checked={show}
                              onClick={(event) => {
                                props.handleQuestionCheck(event, key, "show");
                              }}
                              color="primary"
                              style={{ height: 32, padding: 0 }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  {Object.keys(props.tournament.questions || {})
                    .filter(
                      (key) =>
                        props.tournament.questions[key].perSignup === true
                    )
                    .sort((a, b) => {
                      const qA = props.tournament.questions[a];
                      const qB = props.tournament.questions[b];
                      if (qA.num > qB.num) {
                        return 1;
                      } else if (qA.num < qB.num) {
                        return -1;
                      } else {
                        return 0;
                      }
                    })
                    .map((key) => {
                      const infoField = props.tournament.questions[key];
                      infoField["id"] = key;
                      let show = infoField.show;
                      if (show === undefined) {
                        show = false;
                      }

                      return (
                        <tr key={key}>
                          <td style={{ width: "90%" }}>
                            <Typography variant="body2">
                              {infoField.name}
                            </Typography>
                          </td>
                          <td style={{ width: "10%" }}>
                            <Checkbox
                              checked={show}
                              onClick={(event) => {
                                props.handleQuestionCheck(event, key, "show");
                              }}
                              color="primary"
                              style={{ height: 32, padding: 0 }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </ExpansionPanelDetails>
          )}

        {!props.refereesPage &&
          Object.keys(props.tournament.products || {}).filter(
            (p) => !props.tournament.products[p].alwaysAdd
          ).length > 0 && (
            <ExpansionPanelDetails>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ fontWeight: 500 }}>
                      {languages.signupPage.extraProducts}
                    </td>
                  </tr>
                  {Object.keys(props.tournament.products || {})
                    .filter((p) => !props.tournament.products[p].alwaysAdd)
                    .sort((a, b) => {
                      const pA = props.tournament.products[a];
                      const pB = props.tournament.products[b];
                      if (pA.num > pB.num) {
                        return 1;
                      } else if (pA.num < pB.num) {
                        return -1;
                      } else {
                        return 0;
                      }
                    })
                    .map((key) => {
                      const product = props.tournament.products[key];
                      product["id"] = key;
                      let show = product.show;
                      if (show === undefined) {
                        show = true;
                      }

                      return (
                        <tr key={key}>
                          <td style={{ width: "90%" }}>
                            <Typography variant="body2">
                              {product.name}
                            </Typography>
                          </td>
                          <td style={{ width: "10%" }}>
                            <Checkbox
                              checked={show}
                              onClick={(event) => {
                                props.handleProductCheck(event, key, "show");
                              }}
                              color="primary"
                              style={{ height: 32, padding: 0 }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </ExpansionPanelDetails>
          )}

        {!props.refereesPage &&
          (props.tournament[".key"] === "mHZrY1VskDo2Scfnnn6j" ||
            props.tournament[".key"] === "C6KUKTMksMzAuN3h21Er" ||
            props.tournament[".key"] === "PQruJgfJL1KbH5nlJb8x" ||
            props.tournament[".key"] === "NdXzABVuQWZc4Q3GiTHz" ||
            props.tournament[".key"] === "aVP77PkczLUJdBjCIF4i" ||
            props.tournament[".key"] === "45NTFrpDU0hCnZcaQ1AF" ||
            props.tournament[".key"] === "Ob9tQGgviuwdch6opPd7" ||
            props.tournament[".key"] === "ePAgSKQsqpVI2CQd1Ijq" ||
            props.tournament[".key"] === "fcqagH5pFsHyEOg9BwQE") &&
          props.days.length > 2 && (
            <ExpansionPanelDetails>
              <table style={{ marginTop: 15, width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ fontWeight: 500 }}>
                      {languages.referees.wishes}
                    </td>
                  </tr>
                  {["prefer", "preferNot", "notAvailable"].map((key) => {
                    const wish = (props.tournament.teamWishes || {})[key] || {};
                    wish["id"] = key;
                    let show = wish.show || false;

                    return (
                      <tr key={key}>
                        <td style={{ width: "90%", padding: 0 }}>
                          <Typography
                            variant="body2"
                            style={{ display: "inline" }}
                          >
                            {languages.teamInfo[key + "Wish"]}
                          </Typography>
                        </td>
                        <td style={{ padding: 0 }}>
                          <Checkbox
                            checked={show}
                            onClick={(event) => {
                              props.handleWishCheck(event, key, "show");
                            }}
                            color="primary"
                            style={{ height: 32, padding: 0 }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </ExpansionPanelDetails>
          )}

        {/* Player information fields */}
        {(((props.tournament.defaultFields || {})["players"] || {}).show ||
          (props.tournament.defaultFields || {})["players"] === undefined) &&
          !props.refereesPage &&
          !props.adminsPage &&
          !props.tournament.individualPlayers && (
            <div>
              <ExpansionPanelDetails style={{ overflowX: "auto" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ fontWeight: 500 }}>
                        {languages.teamInfo.playerDataFields}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "80%" }}>
                        <Typography variant="body2">
                          {languages.general.name}
                        </Typography>
                      </td>
                      <td style={{ width: "10%" }}>
                        <EditInfoFieldContainer
                          tournament={props.tournament}
                          infoField={{
                            name: languages.general.name,
                            id: "name",
                          }}
                          disabled={true}
                          playersPage={true}
                        />
                      </td>
                      <td style={{ width: "10%" }}>
                        <Checkbox
                          checked={
                            (
                              (props.tournament.infoFieldsPlayers || {})[
                                "name"
                              ] || {}
                            ).show === undefined ||
                            (
                              (props.tournament.infoFieldsPlayers || {})[
                                "name"
                              ] || {}
                            ).show === true
                          }
                          onClick={(event) => {
                            props.handleCheckPlayers(event, "name", "show");
                          }}
                          color="primary"
                          style={{ height: 32, padding: 0 }}
                          disabled
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "80%" }}>
                        <Typography variant="body2">
                          {(
                            (props.tournament.infoFieldsPlayers || {})["age"] ||
                            {}
                          ).name !== undefined
                            ? (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "age"
                                ] || {}
                              ).name
                            : languages.teams.age}
                        </Typography>
                      </td>
                      <td style={{ width: "10%" }}>
                        <EditInfoFieldContainer
                          tournament={props.tournament}
                          infoField={{
                            name:
                              (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "age"
                                ] || {}
                              ).name !== undefined
                                ? (
                                    (props.tournament.infoFieldsPlayers || {})[
                                      "age"
                                    ] || {}
                                  ).name
                                : languages.teams.age,
                            id: "age",
                            showOnLive:
                              (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "age"
                                ] || {}
                              ).showOnLive || false,
                            trs:
                              (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "age"
                                ] || {}
                              ).trs || {},
                          }}
                          playersPage={true}
                          playersContactInfo={props.playersContactInfo}
                        />
                      </td>
                      <td style={{ width: "10%" }}>
                        <Checkbox
                          checked={
                            (
                              (props.tournament.infoFieldsPlayers || {})[
                                "age"
                              ] || {}
                            ).show === undefined ||
                            (
                              (props.tournament.infoFieldsPlayers || {})[
                                "age"
                              ] || {}
                            ).show === true
                          }
                          onClick={(event) => {
                            props.handleCheckPlayers(event, "age", "show");
                          }}
                          color="primary"
                          style={{ height: 32, padding: 0 }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "80%" }}>
                        <Typography variant="body2">
                          {(
                            (props.tournament.infoFieldsPlayers || {})[
                              "number"
                            ] || {}
                          ).name !== undefined
                            ? (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "number"
                                ] || {}
                              ).name
                            : languages.teams.number}
                        </Typography>
                      </td>
                      <td style={{ width: "10%" }}>
                        <EditInfoFieldContainer
                          tournament={props.tournament}
                          infoField={{
                            name:
                              (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "number"
                                ] || {}
                              ).name !== undefined
                                ? (
                                    (props.tournament.infoFieldsPlayers || {})[
                                      "number"
                                    ] || {}
                                  ).name
                                : languages.teams.number,
                            id: "number",
                            showOnLive:
                              (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "number"
                                ] || {}
                              ).showOnLive ||
                              (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "number"
                                ] || {}
                              ).showOnLive === undefined,
                            trs:
                              (
                                (props.tournament.infoFieldsPlayers || {})[
                                  "number"
                                ] || {}
                              ).trs || {},
                          }}
                          playersPage={true}
                          playersContactInfo={props.playersContactInfo}
                        />
                      </td>
                      <td style={{ width: "10%" }}>
                        <Checkbox
                          checked={
                            (
                              (props.tournament.infoFieldsPlayers || {})[
                                "number"
                              ] || {}
                            ).show === undefined ||
                            (
                              (props.tournament.infoFieldsPlayers || {})[
                                "number"
                              ] || {}
                            ).show === true
                          }
                          onClick={(event) => {
                            props.handleCheckPlayers(event, "number", "show");
                          }}
                          color="primary"
                          style={{ height: 32, padding: 0 }}
                        />
                      </td>
                    </tr>
                    {Object.keys(props.tournament.infoFieldsPlayers || {})
                      .filter(
                        (key) => ["name", "age", "number"].indexOf(key) === -1
                      )
                      .map((key) => {
                        const infoField = Object.assign(
                          {},
                          props.tournament.infoFieldsPlayers[key]
                        );
                        infoField["id"] = key;
                        return (
                          <tr key={key}>
                            <td style={{ width: "80%" }}>
                              <Typography variant="body2">
                                {infoField.name}
                              </Typography>
                            </td>
                            <td style={{ width: "10%" }}>
                              <EditInfoFieldContainer
                                tournament={props.tournament}
                                infoField={infoField}
                                playersContactInfo={props.playersContactInfo}
                                playersPage={true}
                              />
                            </td>
                            <td style={{ width: "10%" }}>
                              <DeleteInfoFieldContainer
                                tournament={props.tournament}
                                infoFieldId={key}
                                playersPage={true}
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </ExpansionPanelDetails>
              <ExpansionPanelDetails>
                <EditInfoFieldContainer
                  tournament={props.tournament}
                  playersPage={true}
                  playersContactInfo={props.playersContactInfo}
                />
              </ExpansionPanelDetails>
            </div>
          )}
      </ExpansionPanel>
    </div>
  );
}

EditInfoCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EditInfoCard);
